module.exports = __webpack_public_path__ + "img/couples-029.a38a7539.jpg";